import { Box, createStyles, makeStyles } from '@material-ui/core';
import * as React from 'react';
import BankCardDynamic from '../../components/BankCard/BankCardDynamic';
import DebtSeparatorWithFlower from '../../components/GeneralComponents/DebtSeparatorWithFlower';
import AccordionNegOptions from '../../components/PortalCajaSocial/AccordionNegOptions';
import DebtIntroductionText from '../../components/PortalCajaSocial/DebtIntroductionText';
import { NegotiationOption, NegotiationOptionAlternative, OutDebt, Profile } from '../../generated/graphql';
import { TranquiTheme } from '../App/theme';
import OutDebtSelector from './OutDebtSelector';
import { transformInfoBank } from './transformInfoBank';

interface DebtDetailsNegOptionsProps {
  profile: Omit<Profile, 'financialSituation'>;
  outDebt: OutDebt;
  outDebts: OutDebt[];
  bankCardInfo: { label: string, value: string }[];
  negOptions: NegotiationOption[];
  gracePeriod: number;
  onChangeGracePeriod: (gracePeriod: number) => void;
  onPreConfirmAlternative: () => void;
  selectedOption: NegotiationOption | null;
  setSelectedOption: React.Dispatch<React.SetStateAction<NegotiationOption | null>>;
  selectedAlternative: NegotiationOptionAlternative | null;
  setSelectedAlternative: React.Dispatch<React.SetStateAction<NegotiationOptionAlternative | null>>;
}

const DebtDetailsNegOptions: React.FC<DebtDetailsNegOptionsProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const {
    profile, outDebt, bankCardInfo, negOptions, gracePeriod, outDebts,
    onChangeGracePeriod, onPreConfirmAlternative,
    selectedOption, ...rest
  } = props;
  const { bank, type } = transformInfoBank(outDebt);
  const document = profile.document || '';

  const belowCardRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <>
      <DebtIntroductionText
        name={profile?.firstname}
        bank={bank}
        document={document}
        variant="details"
        debtType={type}
        extra={outDebt.extra || {}}
        className="mb-1"
      />
      <DebtSeparatorWithFlower />

      <OutDebtSelector className={classes.debtSelector} />
      <Box className={classes.negContainer}>
        <Box className={classes.negContainerStart}>
          <BankCardDynamic
            className={classes.bankCard}
            debt={outDebt}
            info={bankCardInfo}
          />
          <div ref={belowCardRef} />
        </Box>

        <Box className={classes.negContainerEnd}>
          <Box data-test="cy-accordionNegOptions-content">
            {!!negOptions.length && (
              <AccordionNegOptions
                negOptions={negOptions}
                onPreConfirmAlternative={onPreConfirmAlternative}
                outDebt={outDebt}
                selectedOption={selectedOption}
                outDebts={outDebts}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...rest}
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  debtSelector: {
    margin: theme.spacing(0, -2),
    marginBottom: theme.spacing(2),
    position: 'sticky',
    top: theme.spacing(0),
    zIndex: 5,
    background: theme.palette.pearl.main,
    padding: theme.spacing(1, 2, 0),
  },
  bankCard: {
    margin: 'auto',
    marginBottom: theme.spacing(2),
    transition: 'all .4s',
  },
  negContainer: {
    transition: 'all .4s',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      flexDirection: 'row',
    },
  },
  negContainerStart: {
    maxWidth: 350,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: 400,
      flexShrink: 1,
      marginRight: theme.spacing(4),
    },
  },
  negContainerEnd: {
    flexShrink: 2,
  },
}));

export default DebtDetailsNegOptions;
